import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NotFoundComponent } from "./components/pages/not-found/not-found.component";
import { ContactComponent } from "./components/pages/contact/contact.component";
import { HomeComponent } from "./components/pages/home/home.component";
import { ImageGalleryComponent } from "./components/pages/image-gallery/image-gallery.component";
import { ImageFolderComponent } from "./components/pages/image-folder/image-folder.component";
import { VideoGalleryComponent } from "./components/pages/video-gallery/video-gallery.component";
import { VideoFolderComponent } from "./components/pages/video-folder/video-folder.component";
import { AdministrationComponent } from "./components/pages/administration/administration.component";
import { TemplatePageComponent } from "./components/pages/template-page/template-page.component";
import { NoticeComponent } from "./components/pages/notice/notice.component";
import { NewAndEventsItemsComponent } from "./components/pages/new-and-events-items/new-and-events-items.component";
import { NewAndEventsComponent } from "./components/pages/new-and-events/new-and-events.component";
import { AchievementsComponent } from "./components/pages/achievements/achievements.component";
import { AchievementsItemComponent } from "./components/pages/achievements-item/achievements-item.component";
import { OtherNoticesComponent } from "./components/pages/other-notices/other-notices.component";
const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "at-a-glance", component: TemplatePageComponent },
  {
    path: "policy-&-procedures",
    component: TemplatePageComponent,
  },
  {
    path: "academic-level",
    component: TemplatePageComponent,
  },
  {
    path: "academic-term",
    component: TemplatePageComponent,
  },
  {
    path: "other",
    component: OtherNoticesComponent
  },
  {
    path: "academic-term",
    component: TemplatePageComponent,
  },
  {
    path: "syllabus-and-booklist",
    component: TemplatePageComponent,
  },
  {
    path: "six",
    component: TemplatePageComponent,
  },
  {
    path: "seven",
    component: TemplatePageComponent,
  },
  {
    path: "eight",
    component: TemplatePageComponent,
  },
  {
    path: "nine",
    component: TemplatePageComponent,
  },
  {
    path: "co-curricular",
    component: TemplatePageComponent,
  },
  {
    path: "co-curricular",
    component: TemplatePageComponent,
  },
  {
    path: "news-and-events",
    children: [
      { path: "", component: NewAndEventsComponent },
      { path: ":ItemId", component: NewAndEventsItemsComponent },
    ],
  },
  {
    path: "achievements",
    children: [
      { path: "", component: AchievementsComponent },
      { path: ":ItemId", component: AchievementsItemComponent },
    ],
  },
  {
    path: "history",
    component: TemplatePageComponent,
  },
  {
    path: "exam-routine",
    component: TemplatePageComponent,
  },
  {
    path: "other",
    component: TemplatePageComponent,
  },
  {
    path: "course/program",
    component: TemplatePageComponent,
  },

  {
    path: "why-study",
    component: TemplatePageComponent,
  },
  {
    path: "vision",
    component: TemplatePageComponent,
  },
  {
    path: "mission",
    component: TemplatePageComponent,
  },

  {
    path: "oath",
    component: TemplatePageComponent,
  },
  {
    path: "infustructure",
    component: TemplatePageComponent,
  },
  {
    path: "academic-rules",
    component: TemplatePageComponent,
  },
  {
    path: "class-routine",
    component: TemplatePageComponent,
  },
  {
    path: "college-class-routine",
    component: TemplatePageComponent,
  },
  {
    path: "lesson-plan",
    component: TemplatePageComponent,
  },
  {
    path: "academic-calendar",
    component: TemplatePageComponent,
  },
  {
    path: "holiday-calender",
    component: TemplatePageComponent,
  },
  {
    path: "notice-board",
    component: NoticeComponent,
  },
  {
    path: "course-and-program",
    component: TemplatePageComponent,
  },
  {
    path: "syllabus-and-booklist",
    component: TemplatePageComponent,
  },
  {
    path: "prospectus",
    component: TemplatePageComponent,
  },
  {
    path: "magazine",
    component: TemplatePageComponent,
  },
  {
    path: "rules-and-regulations",
    component: TemplatePageComponent,
  },
  {
    path: "uniform",
    component: TemplatePageComponent,
  },
  {
    path: "suggestion",
    component: TemplatePageComponent,
  },
  {
    path: "online-information ",
    component: TemplatePageComponent,
  },
  {
    path: "coordinator",
    component: TemplatePageComponent,
  },
  {
    path: "our-curriculum",
    component: TemplatePageComponent,
  },
  {
    path: "extra-co-curricular",
    component: TemplatePageComponent,
  },
  {
    path: "class-time-schedule",
    component: TemplatePageComponent,
  },
  {
    path: "club-activity",
    component: TemplatePageComponent,
  },
  {
    path: "admission-circular",
    component: TemplatePageComponent,
  },
  {
    path: "admission-form",
    component: TemplatePageComponent,
  },

  {
    path: "do’s-&-don’ts",
    component: TemplatePageComponent,
  },

  {
    path: "general-discipline",
    component: TemplatePageComponent,
  },

  {
    path: "mode-of-motivation",
    component: TemplatePageComponent,
  },

  {
    path: "half-yearly",
    component: TemplatePageComponent,
  },

  {
    path: "ssc-results",
    component: TemplatePageComponent,
  },

  {
    path: "test",
    component: TemplatePageComponent,
  },

  {
    path: "yearly",
    component: TemplatePageComponent,
  },

  {
    path: "payment-procedure",
    component: TemplatePageComponent,
  },

  {
    path: "fees-payment",
    component: TemplatePageComponent,
  },

  {
    path: "selected-candidates",
    component: TemplatePageComponent,
  },
  {
    path: "waiting-list",
    component: TemplatePageComponent,
  },
  {
    path: "admission-result",
    component: TemplatePageComponent,
  },
  {
    path: "exam-rules",
    component: TemplatePageComponent,
  },
  {
    path: "courses-and-program",
    component: TemplatePageComponent,
  },
  {
    path: "faq",
    component: TemplatePageComponent,
  },
  {
    path: "admission-procedure",
    component: TemplatePageComponent,
  },
  {
    path: "payment-process",
    component: TemplatePageComponent,
  },
  {
    path: "download-admit-card",
    component: TemplatePageComponent,
  },
  {
    path: "admission-instruction",
    component: TemplatePageComponent,
  },
  {
    path: "student-advisor",
    component: TemplatePageComponent,
  },
  {
    path: "academic-organogram",
    component: TemplatePageComponent,
  },
  {
    path: "institution-result",
    component: TemplatePageComponent,
  },
  {
    path: "board-result",
    component: TemplatePageComponent,
  },
  {
    path: "scholarship-result",
    component: TemplatePageComponent,
  },
  {
    path: "admission-test-result",
    component: TemplatePageComponent,
  },
  {
    path: "recruitment",
    component: TemplatePageComponent,
  },
  {
    path: "ict-club",
    component: TemplatePageComponent,
  },
  {
    path: "science-club",
    component: TemplatePageComponent,
  },
  {
    path: "debate-club",
    component: TemplatePageComponent,
  },
  {
    path: "photography-club",
    component: TemplatePageComponent,
  },
  {
    path: "recruitment-result",
    component: TemplatePageComponent,
  },
  {
    path: "cultural-club",
    component: TemplatePageComponent,
  },
  {
    path: "quiz-club",
    component: TemplatePageComponent,
  },
  {
    path: "it-club",
    component: TemplatePageComponent,
  },
  {
    path: "business-club",
    component: TemplatePageComponent,
  },
  {
    path: "blood-donation-club",
    component: TemplatePageComponent,
  },
  {
    path: "quran-learning-club",
    component: TemplatePageComponent,
  },
  {
    path: "general-knowledge-club",
    component: TemplatePageComponent,
  },
  {
    path: "tour",
    component: TemplatePageComponent,
  },
  {
    path: "language-club",
    component: TemplatePageComponent,
  },
  {
    path: "sports-&-karate-club",
    component: TemplatePageComponent,
  },
  {
    path: "sports",
    component: TemplatePageComponent,
  },
  {
    path: "physics",
    component: TemplatePageComponent,
  },
  {
    path: "chemistry",
    component: TemplatePageComponent,
  },
  {
    path: "bncc-society",
    component: TemplatePageComponent,
  },
  {
    path: "rover scout society",
    component: TemplatePageComponent,
  },
  {
    path: "scout",
    component: TemplatePageComponent,
  },
  {
    path: "bncc",
    component: TemplatePageComponent,
  },
  {
    path: "football-society",
    component: TemplatePageComponent,
  },
  {
    path: "cricket-society",
    component: TemplatePageComponent,
  },
  {
    path: "jsc-results",
    component: TemplatePageComponent,
  },
  {
    path: "syllabus",
    component: TemplatePageComponent,
  },
  {
    path: "internal-exam-result",
    component: TemplatePageComponent,
  },
  {
    path: "public-exam-results",
    component: TemplatePageComponent,
  },
  {
    path: "mission-and-vision",
    component: TemplatePageComponent,
  },
  {
    path: "program",
    component: TemplatePageComponent,
  },
  {
    path: "fees",
    component: TemplatePageComponent,
  },
  {
    path: "classrooms",
    component: TemplatePageComponent,
  },
  {
    path: "computer-lab",
    component: TemplatePageComponent,
  },
  {
    path: "science-lab",
    component: TemplatePageComponent,
  },
  {
    path: "library",
    component: TemplatePageComponent,
  },
  {
    path: "playground",
    component: TemplatePageComponent,
  },
  {
    path: "canteen",
    component: TemplatePageComponent,
  },
  {
    path: "auditorium",
    component: TemplatePageComponent,
  },
  {
    path: "math-club",
    component: TemplatePageComponent,
  },
  {
    path: "recitation-club",
    component: TemplatePageComponent,
  },
  {
    path: "drama-club",
    component: TemplatePageComponent,
  },
  {
    path: "music-club",
    component: TemplatePageComponent,
  },
  {
    path: "dance-society",
    component: TemplatePageComponent,
  },
  {
    path: "transports",
    component: TemplatePageComponent,
  },
  {
    path: "sports-club",
    component: TemplatePageComponent,
  },
  {
    path: "sports-&-game",
    component: TemplatePageComponent,
  },
  {
    path: "class-rooms",
    component: TemplatePageComponent,
  },
  {
    path: "play-ground",
    component: TemplatePageComponent,
  },
  {
    path: "acknowledgement-and-permission",
    component: TemplatePageComponent,
  },
  {
    path: "section-approval",
    component: TemplatePageComponent,
  },
  {
    path: "tour",
    component: TemplatePageComponent,
  },
  {
    path: "scout",
    component: TemplatePageComponent,
  },
  {
    path: "bncc",
    component: TemplatePageComponent,
  },
  {
    path: "at-a-glance",
    component: TemplatePageComponent,
  },
  {
    path: "history",
    component: TemplatePageComponent,
  },
  {
    path: "news-and-events",
    component: TemplatePageComponent,
  },
  {
    path: "achievements",
    component: TemplatePageComponent,
  },
  {
    path: "infustructure",
    component: TemplatePageComponent,
  },
  {
    path: "class-routine",
    component: TemplatePageComponent,
  },
  {
    path: "student-statistics",
    component: TemplatePageComponent,
  },
  {
    path: "academic-rules",
    component: TemplatePageComponent,
  },
  {
    path: "academic-calendar",
    component: TemplatePageComponent,
  },
  {
    path: "notice",
    component: TemplatePageComponent,
  },
  {
    path: "syllabus-and-booklist",
    component: TemplatePageComponent,
  },
  {
    path: "public-results",
    component: TemplatePageComponent,
  },
  {
    path: "admission-prospectus",
    component: TemplatePageComponent,
  },
  {
    path: "admission-circular",
    component: TemplatePageComponent,
  },
  {
    path: "admission-result",
    component: TemplatePageComponent,
  },
  {
    path: "administration/message-of-head-master",
    component: TemplatePageComponent,
  },
  {
    path: "administration/governing-body",
    component: TemplatePageComponent,
  },
  {
    path: "administration/message-of-chairman",
    component: TemplatePageComponent,
  },
  {
    path: "administration/message-of-vice-chairman",
    component: TemplatePageComponent,
  },
  {
    path: "administration/teacher-information",
    component: TemplatePageComponent,
  },
  {
    path: "administration/staff-information",
    component: TemplatePageComponent,
  },
  {
    path: "photo-gallery",
    component: TemplatePageComponent,
  },
  {
    path: "video-gallery",
    component: TemplatePageComponent,
  },
  {
    path: "information-service-center",
    component: TemplatePageComponent,
  },
  {
    path: "complaint-resolution-officer",
    component: TemplatePageComponent,
  },
  ,
  ,

  ,
  {
    path: "help-desk-of-bhksc",
    component: TemplatePageComponent,
  },
  {
    path: "case-solving-officer",
    component: TemplatePageComponent,
  },
  {
    path: "academic-permission",
    component: TemplatePageComponent,
  },

  {
    path: "class-wise-student-information",
    component: TemplatePageComponent,
  },
  {
    path: "class-&-section",
    component: TemplatePageComponent,
  },
  // {
  //   path: "administration",
  //   children: [
  //     { path: "", component: AdministrationComponent },
  //     { path: ":item", component: AdministrationComponent },
  //   ],
  // },

  {
    path: "student's-login",
    component: TemplatePageComponent,
  },
  {
    path: "teacher's-login",
    component: TemplatePageComponent,
  },
  { path: "photos", component: ImageGalleryComponent },
  { path: "videos", component: VideoGalleryComponent },
  { path: "photo-gallery", component: ImageGalleryComponent },
  { path: "video-gallery", component: VideoGalleryComponent },
  {
    path: "administration",
    children: [
      { path: "", component: AdministrationComponent },
      { path: ":item", component: AdministrationComponent },
    ],
  },

  { path: "contact", component: ContactComponent },
  {
    path: "imageFolder",
    children: [
      { path: "", component: ImageFolderComponent },
      { path: ":folderId", component: ImageFolderComponent },
    ],
  },
  {
    path: "videoFolder",
    children: [
      { path: "", component: VideoFolderComponent },
      { path: ":folderId", component: VideoFolderComponent },
    ],
  },
  // Here add new pages component

  { path: "**", component: NotFoundComponent }, // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'disabled',   // Lenis handles scroll-to-top on route change
    anchorScrolling: 'disabled',
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
